// @ts-nocheck
import { getDisplayProductPricesPolicy } from "@store/Framework/Store/Context/ContextSelectors";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SetUserFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

replaceInChain(chain, SetUserFields, props => {
    const { parameter, result } = props;
    if (!result.updatedUser) {
        throw new Error("There was no editingUser set and we are trying to update it.");
    }
    result.updatedUser.email = typeof parameter.email !== "undefined" ? parameter.email : result.updatedUser.email;
    result.updatedUser.firstName =
        typeof parameter.firstName !== "undefined" ? parameter.firstName : result.updatedUser.firstName;
    result.updatedUser.lastName =
        typeof parameter.lastName !== "undefined" ? parameter.lastName : result.updatedUser.lastName;
    result.updatedUser.role = typeof parameter.role !== "undefined" ? parameter.role : result.updatedUser.role;
    result.updatedUser.approver =
        typeof parameter.approver !== "undefined" ? parameter.approver : result.updatedUser.approver;
    result.updatedUser.isApproved =
        typeof parameter.isApproved !== "undefined" ? parameter.isApproved : result.updatedUser.isApproved;

    // Foundation --->
    const state = props.getState();
    const displayProductPricesPolicy = getDisplayProductPricesPolicy(state);

    if (displayProductPricesPolicy) {
        result.updatedUser.properties = {
            canSeePricesPolicy:
                typeof (parameter as AccountModel).properties?.canSeePricesPolicy !== "undefined"
                    ? (parameter as AccountModel).properties?.canSeePricesPolicy
                    : result.updatedUser.properties?.canSeePricesPolicy,
        };
    }
    // <--- Foundation
});
